import { AsyncGridColumns, ColumnValue } from '~/shared/ui/AsyncGrid'
import { GridRow } from './types'

export const columns: AsyncGridColumns<GridRow> = [
  {
    headerName: 'column.part and extent of damage',
    field: 'description',
    flex: 1,
  },
  {
    headerName: 'column.cost',
    field: 'cost',
    flex: 1,
    renderCell: ({ value }) => (
      <ColumnValue>{value.toLocaleString()}</ColumnValue>
    ),
  },
]
